// src/app/modules/Dashboard/_redux/dashboard/Actions.js
import * as requestFromServer from "./Crud";
import { toast } from "react-toastify";
import { DashboardSlice, callTypes } from "./Slice";
import * as billingCrud from "./Crud.billing";
const { actions } = DashboardSlice;

export const fetchAllData = (type, queryParams, paginationParams) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findDatas(type, queryParams, paginationParams)
    .then(response => {
      var res = response.data;
      
      if (type === 'dashboard_data') {
        dispatch(actions.dashboardData(res.data));
      } else if (type === 'users') {
        dispatch(actions.accounts(res.data.data));
        dispatch(actions.accountsMeta(res.data.meta ? res.data.meta : null));
      } else if (type === 'access_codes') {
        dispatch(actions.accessCodes(res.results || []));
        dispatch(actions.accessCodesMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      } else if (type === 'access_logs') {
        dispatch(actions.accessLogs(res.results || []));
        dispatch(actions.accessLogsMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      } else if (type === 'access_code_stats') {
        dispatch(actions.accessCodeStats(res));
      } else if (type === 'security_analytics') {
        dispatch(actions.securityAnalytics(res.data));
      } else if (type === 'threat_alerts') {
        dispatch(actions.threatAlerts(res.results || []));
        dispatch(actions.threatAlertsMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      } else if (type === 'members') {
        dispatch(actions.members(res.results || []));
        dispatch(actions.membersMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      }  else if (type === 'integrations') {
        const raw = res.data || res.integrations || res.results || res;
        const intList = Array.isArray(raw) ? raw : [];
        dispatch(actions.integrations(intList));
        return res;
    
      } else if (type === 'integration_sync_logs') {
        dispatch(actions.integrationSyncLogs({
          logs: res.logs || [],
          meta: { page: res.page, limit: res.limit, total: res.total },
        }));
        return res;
      } else if (type === 'blacklist') {
        dispatch(actions.blacklist(res.results || []));
        dispatch(actions.blacklistMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      }else if (type === 'spaces') {
        dispatch(actions.space(res.results || []));
        dispatch(actions.spaceMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
        return res;
      } else if (type === 'live_overview') {
    dispatch(actions.setLiveStaff(res.staff || []));
    dispatch(actions.setLiveKPI(res.kpi   || null));
    return res;
 
  } else if (type === 'resident_live') {
    dispatch(actions.setResidentLive(res.residents || []));
    dispatch(actions.setResidentLiveSummary(res.summary || null));
    return res;
 
  } else if (type === 'visitor_live') {
    dispatch(actions.setVisitorLive(res.visitors || []));
    dispatch(actions.setVisitorLiveSummary(res.summary || null));
    return res;
 
  } else if (type === 'mgmt_analytics') {
    dispatch(actions.setMgmtAnalytics(res));
    return res;
  } else if (type === 'incidents') {
        dispatch(actions.incidents(res.results || []));
        dispatch(actions.incidentsMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      } else if (type === 'incident') {
        dispatch(actions.incidentDetails(res));
        return res;
      } else if (type === 'incident_stats') {
        dispatch(actions.incidentStats(res));
      } else if (type === 'blacklist_stats') {
        dispatch(actions.networkStats(res));
      } else if (type === 'member') {
        dispatch(actions.memberDetails(res));
        return res;
      } else if (type === 'member_stats') {
        dispatch(actions.memberStats(res));
      } else if (type === 'reports') {
        // Handle different response formats
        if (res.results) {
          // Paginated
          dispatch(actions.reports(res.results));
          dispatch(actions.reportsMeta({
            page: res.page,
            limit: res.limit,
            totalPages: res.totalPages,
            totalResults: res.totalResults,
          }));
        } else if (res.data) {
          // Simple array in data
          dispatch(actions.reports(res.data));
        } else if (Array.isArray(res)) {
          // Direct array
          dispatch(actions.reports(res));
        }
      } else if (type === 'safety_score') {
          dispatch(actions.safetyScore(res));
        } else if (type === 'time_analysis') {
          dispatch(actions.timeAnalysis(res));
        } else if (type === 'nearby_incidents') {
          // Transform danger zones response to match expected format
          const incidents = (res.results || []).map(incident => ({
            id: incident._id,
            type: incident.incident_type,
            severity: getSeverityLevel(incident.severity),
            severityScore: incident.severity,
            location: incident.location?.address || incident.location?.city || 'Unknown',
            city: incident.location?.city,
            coordinates: incident.location?.coordinates,
            time: getTimeAgo(new Date(incident.date)),
            verified: incident.verified || false,
            details: incident.description,
            source: incident.source
          }));
          dispatch(actions.nearbyIncidents(incidents));
        } else if (type === 'incident_patterns') {
          dispatch(actions.incidentPatterns(res));
        } else if (type === 'risk_prediction') {
          dispatch(actions.riskPrediction(res));
        }


     

      else if (type === 'intelligence_hotspots') {
        dispatch(actions.intelligence_hotspots(res.hotspots || res));
      } else if (type === 'intelligence_heatmap') {
        dispatch(actions.intelligence_heatmap(res));
      } else if (type === 'intelligence_time') {
        dispatch(actions.intelligence_time(res));
      } else if (type === 'intelligence_location_risk') {
        dispatch(actions.intelligence_location_risk(res));
      }
      // NEW: Visitors
      else if (type === 'visitors') {
        dispatch(actions.visitors(res.results || []));
        dispatch(actions.visitorsMeta({
          page: res.page,
          limit: res.limit,
          totalPages: res.totalPages,
          totalResults: res.totalResults,
        }));
      } else if (type === 'visitor_profile') {
        dispatch(actions.visitorProfile(res));
        return res;
      } else if (type === 'visitor_activity') {
        dispatch(actions.visitorActivity(res));
        return res;
      } else if (type === 'visitor_stats') {
        dispatch(actions.visitorStats(res));
      } else if (type === 'high_risk_visitors') {
        dispatch(actions.highRiskVisitors(res.results || []));
      } else if (type === 'staff') {
        dispatch(actions.staff(res.data.staff || []));
        dispatch(actions.staffMeta({
          count: res.data.count || 0,
        }));
      }
      else if (type === 'active_staff') {
        dispatch(actions.activeStaff(res.data.staff || []));
      }
      else if (type === 'staff_attendance') {
        dispatch(actions.staffAttendance(res.data || res));
      }
      else if (type === 'staff_details') {
        dispatch(actions.staffDetails(res.data || res));
        return res.data || res;
      }


        else if (type === 'billing_plans') {
          dispatch(actions.billingPlans(res.plans || []));
        }
        else if (type === 'subscription') {
          dispatch(actions.subscriptionFetching());
          dispatch(actions.subscription(res));
        }
        else if (type === 'invoices') {
          dispatch(actions.invoices(res.invoices || []));
          dispatch(actions.invoicesMeta({
            page: res.page,
            limit: res.limit,
            totalPages: res.totalPages || Math.ceil(res.total / res.limit),
            totalResults: res.total,
          }));
        }
        else if (type === 'invoice') {
          dispatch(actions.invoiceDetail(res.invoice || res));
          return res;
        }
        else if (type === 'payment_methods') {
          dispatch(actions.paymentMethods(res.payment_methods || []));
        }

      // ============================================
      // RESIDENT OPERATIONS
      // ============================================
      else if (type === 'residents') {
        dispatch(actions.residents(res.data.residents || []));
        dispatch(actions.residentsMeta({
          count: res.data.count || 0,
        }));
      }
      else if (type === 'resident_details') {
        dispatch(actions.residentDetails(res.data || res));
        return res.data || res;
      }
      else if (type === 'resident_by_unit') {
        dispatch(actions.residentDetails(res.data || res));
        return res.data || res;
      }
      else if (type === 'resident_history') {
        dispatch(actions.residentHistory(res.data || res));
      }

      // ============================================
      // UNIFIED DASHBOARD
      // ============================================
      else if (type === 'unified_dashboard') {
        dispatch(actions.unifiedDashboard(res.data || res));
      }
      else if (type === 'operations_logs') {
        dispatch(actions.operationsLogs(res.data.results || []));
        dispatch(actions.operationsLogsMeta({
          page: res.data.page,
          limit: res.data.limit,
          totalPages: res.data.totalPages,
          totalResults: res.data.totalResults,
        }));
      }
      else if (type === 'capacity_status') {
        dispatch(actions.capacityStatus(res.data || res));
      }
      else if (type === 'operations_analytics') {
        dispatch(actions.operationsAnalytics(res.data || res));
      }

      // ── Events ──────────────────────────────────────────────────────────
      else if (type === 'events') {
        dispatch(actions.events(res.data?.events || res.data || []));
        dispatch(actions.eventsMeta({
          page: res.data?.page, limit: res.data?.limit,
          totalPages: res.data?.totalPages, totalResults: res.data?.totalResults,
        }));
      }
      else if (type === 'event') {
        dispatch(actions.eventDetail(res.data || res));
        return res.data || res;
      }
      else if (type === 'event_orders') {
        dispatch(actions.eventOrders(res.data?.orders || res.data || []));
        dispatch(actions.eventOrdersMeta({
          page: res.data?.page, limit: res.data?.limit,
          totalPages: res.data?.totalPages, totalResults: res.data?.totalResults,
        }));
      }
      else if (type === 'all_orders') {
        dispatch(actions.allOrders(res.data?.orders || res.data || []));
        dispatch(actions.allOrdersMeta({
          page: res.data?.page, limit: res.data?.limit,
          totalPages: res.data?.totalPages, totalResults: res.data?.totalResults,
        }));
      }
      else if (type === 'event_stats') {
        dispatch(actions.eventStats(res.data || res));
      }

      // ── Wallet ───────────────────────────────────────────────────────────
      else if (type === 'wallet') {
        dispatch(actions.wallet(res.data || res));
      }
      else if (type === 'wallet_transactions') {
        dispatch(actions.walletTransactions(res.data?.transactions || res.data || []));
        dispatch(actions.walletTransactionsMeta({
          page: res.data?.page, limit: res.data?.limit,
          totalPages: res.data?.totalPages, totalResults: res.data?.totalResults,
        }));
      }
      else if (type === 'bank_accounts') {
        dispatch(actions.bankAccounts(res.data?.bank_accounts || res.data || []));
      }

      else {
        return res;
      }

    })
    .catch(error => {
      var message = error.response?.data?.message || "Server error occurred. Please try again!";
      toast.error(message);
      error.clientMessage = "Can't find Data";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return null;
    });
};

export const fetchData = id => dispatch => {
  if (!id) {
    return dispatch(actions.DataFetched({ DataForEdit: undefined }));
  }
};

export const deleteData = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteData(id)
    .then(response => {
      dispatch(actions.DataDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete Data";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

function isValidJson(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (error) {
    return false;
  }
}



const getSeverityLevel = (severity) => {
  if (severity >= 9) return 'critical';
  if (severity >= 7) return 'high';
  if (severity >= 4) return 'medium';
  return 'low';
};

const getTimeAgo = (date) => {
  const seconds = Math.floor((new Date() - date) / 1000);
  
  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} mins ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)} days ago`;
  
  return date.toLocaleDateString();
};

export const addData = (type, DataForCreation, orgId = '') => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .addNewData(type, DataForCreation, orgId)
    .then(response => {
      var res = response.data;
      dispatch(actions.stopLoading());
      // console.log('Add Data response:', res);
      
      if (type === 'code') {
        toast.success("New access code successfully generated");
        dispatch(actions.codeAdded(res.code));
        return res;
      } else if (type === 'validate_code') {
        const validationResult = res;
        
        if (validationResult.valid) {
          dispatch(fetchAllData('access_logs', orgId, { page: 1, perPage: 10 }));
          return validationResult;
        }
        return res;
      } else if (type === 'checkout_visitor') {
        toast.success("Visitor checked out successfully");
        return res;
      } else if (type === 'update_space') {
        toast.success("Space successfully updated");
        return res;
      } else if (type === 'add_member') {
        toast.success("Member added successfully");
        dispatch(actions.memberAdded(res));
        return res;
      } else if (type === 'update_member') {
        toast.success("Member updated successfully");
        dispatch(actions.memberUpdated(res));
        return res;
      } else if (type === 'suspend_member') {
        toast.success("Member suspended successfully");
        dispatch(actions.memberSuspended(res));
        return res;
      } else if (type === 'request_report') {
        toast.success('Report queued — results will arrive by email');
        return res;
      } else if (type === 'scim_setup') {
        const data = res?.data || res;
        if (data?.integration_id) {
          dispatch(actions.integrationAdded({ integration_id: data.integration_id, provider: DataForCreation?.provider, status: 'active', credentials_summary: { has_bearer_token: true } }));
        }
        return res;
      } else if (type === 'teams_setup') {
        const data = res?.data || res;
        if (data?.integration_id) {
          dispatch(actions.integrationAdded({ integration_id: data.integration_id, provider: 'microsoft_teams', status: 'active', credentials_summary: { has_incoming_webhook: true, has_outgoing_token: !!DataForCreation?.outgoing_webhook_token } }));
        }
        toast.success('Microsoft Teams connected');
        return res;
      } else if (type === 'create_integration') {
        toast.success('Integration connected successfully');
        dispatch(actions.integrationAdded(res.integration || res));
        return res;
    
      } else if (type === 'update_integration') {
        toast.success('Integration settings saved');
        dispatch(actions.integrationUpdated(res.integration || res));
        return res;
    
      } else if (type === 'delete_integration') {
        toast.success('Integration disconnected');
        dispatch(actions.integrationDeleted(orgId));   // orgId is integration_id
        return res;
    
      } else if (type === 'trigger_sync') {
        toast.success('Sync triggered — results will appear shortly');
        return res;
    
      } else if (type === 'get_oauth_url') {
        // caller handles the redirect — no toast needed
        return res;
      } else if (type === 'generate_scim_token') {
        toast.success('SCIM token generated');
        dispatch(actions.integrationUpdated(res.integration || res));
        return res;
      } else if (type === 'oauth_callback') {
        dispatch(actions.integrationAdded(res.integration || res));
        return res;
      } else if (type === 'calendar_setup_watch') {
        toast.success('Calendar watch configured');
        return res;
      } else if (type === 'calendar_preview') {
        return res;
      } else if (type === 'calendar_events') {
        return res;
      } else if (type === 'update_calendar_settings') {
        toast.success('Calendar settings saved');
        dispatch(actions.integrationUpdated(res?.data || res));
        return res;
      } else if (type === 'supervisor_visitor_checkin') {
        dispatch(actions.updateVisitorLiveStatus({ log_id: orgId, status: 'checked_in' }));
        toast.success('Visitor checked in');
        return res;
      } else if (type === 'visitor_checkin_from_code') {
        // Optimistic update: find by code_id and mark as checked_in
        dispatch(actions.updateVisitorByCodeId({ code_id: DataForCreation.code_id, status: 'checked_in', log_id: res.log_id }));
        toast.success('Visitor checked in');
        return res;
      
      }
      else if (type === 'force_clock_out') {
    // queryId was the staff user_id — optimistic update
    dispatch(actions.updateLiveStaffStatus({ user_id: orgId, status: 'off_duty' }));
    // NOTE: orgId is the 3rd param to addData() — pass the staff user_id there
    toast.success('Staff clocked out');
    return res;
 
  } else if (type === 'supervisor_visitor_checkout') {
    dispatch(actions.updateVisitorLiveStatus({ log_id: orgId, status: 'checked_out' }));
    toast.success('Visitor checked out');
    return res;
 
  } else if (type === 'correct_shift') {
    toast.success('Shift corrected — audit log saved');
    return res;
 
  } else if (type === 'bulk_staff_action') {
    const { staff_ids, action } = DataForCreation;
    if (action === 'clockout') {
      staff_ids.forEach(id => dispatch(actions.updateLiveStaffStatus({ user_id: id, status: 'off_duty' })));
    } else if (action === 'break_start') {
      staff_ids.forEach(id => dispatch(actions.updateLiveStaffStatus({ user_id: id, status: 'on_break' })));
    } else if (action === 'break_end') {
      staff_ids.forEach(id => dispatch(actions.updateLiveStaffStatus({ user_id: id, status: 'on_duty' })));
    }
    toast.success(`${action} applied to ${staff_ids.length} staff`);
    return res;
 
  } else if (type === 'update_member_role') {
    dispatch(actions.updateLiveStaffRole({ membership_id: orgId, role: DataForCreation.new_role }));
    toast.success(`Role updated to ${DataForCreation.new_role}`);
    return res;
 
  } else if (type === 'toggle_supervisor') {
    toast.success(DataForCreation.is_supervisor ? 'Promoted to supervisor' : 'Supervisor access removed');
    return res;
 
  } else if (type === 'assign_staff_spaces') {
    toast.success('Spaces assigned');
    return res;
 
  } else if (type === 'assign_resident_location') {
    toast.success('Location updated');
    return res;
  } else if (type === 'reactivate_member') {
        toast.success("Member reactivated successfully");
        dispatch(actions.memberReactivated(res));
        return res;
      } else if (type === 'delete_member') {
        toast.success("Member removed successfully");
        dispatch(actions.memberDeleted(DataForCreation.membership_id));
        return res;
      } else if (type === 'create_incident') {
        toast.success("Incident reported successfully");
        return res;
      } else if (type === 'respond_to_incident') {
        toast.success("Response recorded");
        return res;
      } // In addData function, add:
      else if (type === 'generate_report') {
        toast.success("Report generation started");
        return res;
      } else if (type === 'export_report_pdf') {
        toast.success("Exporting report...");
        return res;
      } else if (type === 'add_incident_update') {
        toast.success("Update added");
        return res;
      } else if (type === 'resolve_incident') {
        toast.success("Incident resolved");
        return res;
      }
      // NEW: Invite Members
      else if (type === 'invite_members') {
        const result = res;
        const totalInvited = result.invited?.length || 0;
        const totalErrors = result.errors?.length || 0;
        const totalAlready = result.already_members?.length || 0;
        
        if (totalInvited > 0) {
          toast.success(`Successfully sent ${totalInvited} invitation${totalInvited !== 1 ? 's' : ''}`);
        }
        
        if (totalAlready > 0) {
          toast.info(`${totalAlready} user${totalAlready !== 1 ? 's are' : ' is'} already a member`);
        }
        
        if (totalErrors > 0) {
          toast.warning(`${totalErrors} invitation${totalErrors !== 1 ? 's' : ''} failed`);
        }
        
        dispatch(actions.membersInvited(result));
        return result;
      } else if (type === 'acknowledge_alert') {
        toast.success("Alert acknowledged successfully");
        return res;
      } else if (type === 'resolve_alert') {
        toast.success("Alert resolved successfully");
        return res;
      }
      else if (type === 'resend_invite') {
        toast.success("Invitation resent successfully");
        dispatch(actions.inviteResent(res));
        return res;
      }
      else if (type === 'cancel_invite') {
        toast.success("Invitation cancelled successfully");
        dispatch(actions.inviteCancelled(DataForCreation.membership_id));
        return res;
      }
      else if (type === 'add_to_blacklist') {
        toast.success("Added to blacklist successfully");
        return res;
      } else if (type === 'remove_from_blacklist') {
        toast.success("Removed from blacklist successfully");
        return res;
      }
      // Visitor actions
      else if (type === 'flag_visitor') {
        toast.success("Visitor flagged successfully");
        dispatch(actions.visitorFlagged(res));
        return res;
      } else if (type === 'threat_alert') {
        toast.success("Threat alert created successfully");
        dispatch(actions.threatAlertAdded(res));
        return res;
      } else if (type === 'blacklist_visitor') {
        toast.success("Visitor added to blacklist");
        dispatch(actions.visitorBlacklisted(res));
        return res;
      }


      else if (type === 'pay_invoice') {
        toast.success("Invoice paid successfully");
        dispatch(actions.invoicePaid(res.invoice || res));
        return res;
      }
      else if (type === 'cancel_subscription') {
        toast.success("Subscription will cancel at end of billing period");
        dispatch(actions.subscriptionCancelled(res.subscription || res));
        return res;
      }
      else if (type === 'remove_payment_method') {
        toast.success("Payment method removed");
        dispatch(actions.paymentMethodRemoved(DataForCreation.payment_method_id));
        return res;
      }
      else if (type === 'set_default_payment_method') {
        toast.success("Default payment method updated");
        dispatch(actions.defaultPaymentMethodSet(res.payment_method || res));
        return res;
      }

      // ── Events mutations ─────────────────────────────────────────────────
      else if (type === 'create_event') {
        toast.success("Event created successfully");
        dispatch(actions.eventAdded(res.event || res));
        return res.event || res;
      }
      else if (type === 'update_event') {
        toast.success("Event updated successfully");
        dispatch(actions.eventUpdated(res.event || res));
        return res.event || res;
      }
      else if (type === 'publish_event') {
        toast.success("Event published");
        dispatch(actions.eventUpdated({ ...(res.event || res), status: 'published' }));
        return res.event || res;
      }
      else if (type === 'cancel_event') {
        toast.success("Event cancelled");
        dispatch(actions.eventUpdated({ ...(res.event || res), status: 'cancelled' }));
        return res.event || res;
      }
      else if (type === 'delete_event') {
        toast.success("Event deleted");
        dispatch(actions.eventDeleted(orgId));
        return res;
      }

      // ── Wallet mutations ─────────────────────────────────────────────────
      else if (type === 'request_payout') {
        toast.success("Payout request submitted");
        return res;
      }
      else if (type === 'add_bank_account') {
        toast.success("Bank account added");
        dispatch(actions.bankAccountAdded(res.bank_account || res));
        return res.bank_account || res;
      }
      else if (type === 'remove_bank_account') {
        toast.success("Bank account removed");
        dispatch(actions.bankAccountRemoved(orgId));
        return res;
      }
      else if (type === 'set_default_bank_account') {
        toast.success("Default bank account updated");
        dispatch(actions.defaultBankAccountSet(orgId));
        return res;
      }

      return res;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Server error occurred. Please try again!";
      error.clientMessage = "Can't create Data";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      if (type === 'validate_code') {
        throw error;
        return;
      }
      toast.error(!isValidJson(message) ? message : message?.error || "Server error occurred. Please try again!");
      throw error; // Re-throw so the component can handle it
    });
};



export const revokeCode = (codeId, reason, orgId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .revokeAccessCode(codeId, reason)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Access code revoked successfully");
      dispatch(fetchAllData('access_codes', orgId, { page: 1, perPage: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to revoke access code";
      toast.error(message);
      error.clientMessage = "Can't revoke access code";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// Generate Security Report
export const generateSecurityReport = (organizationId, startDate, endDate) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .generateSecurityReport({
      organization_id: organizationId,
      start_date: startDate,
      end_date: endDate,
    })
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Security report generated successfully");
      dispatch(fetchAllData('security_analytics', organizationId));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to generate security report";
      toast.error(message);
      error.clientMessage = "Can't generate security report";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// NEW: Recalculate visitor risk score
export const recalculateVisitorRisk = (profileId, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .recalculateVisitorRisk(profileId)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Risk score recalculated successfully");
      // Refresh visitor list
      dispatch(fetchAllData('visitors', organizationId, { page: 1, limit: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to recalculate risk score";
      toast.error(message);
      error.clientMessage = "Can't recalculate risk";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// NEW: Unflag visitor
export const unflagVisitor = (profileId, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .unflagVisitor(profileId)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Visitor unflagged successfully");
      dispatch(actions.visitorUnflagged(response.data));
      // Refresh visitor list
      dispatch(fetchAllData('visitors', organizationId, { page: 1, limit: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to unflag visitor";
      toast.error(message);
      error.clientMessage = "Can't unflag visitor";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateData = Data => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateData(Data)
    .then(() => {
      dispatch(actions.DataUpdated({ Data }));
    })
    .catch(error => {
      error.clientMessage = "Can't update Data";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateDatasStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForDatas(ids, status)
    .then(() => {
      dispatch(actions.DatasStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update Datas status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteDatas = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteDatas(ids)
    .then(() => {
      dispatch(actions.DatasDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete Datas";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};




export const staffCheckIn = (checkInData, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .staffCheckIn(checkInData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Staff checked in successfully");
      // Refresh access logs
      dispatch(fetchAllData('access_logs', organizationId, { page: 1, perPage: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to check in";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const staffCheckOut = (checkOutData, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .staffCheckOut(checkOutData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Staff checked out successfully");
      // Refresh access logs
      dispatch(fetchAllData('access_logs', organizationId, { page: 1, perPage: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to check out";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const staffStartBreak = (breakData, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .staffStartBreak(breakData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Break started");
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to start break";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const staffEndBreak = (breakData, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .staffEndBreak(breakData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Break ended");
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to end break";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

// ============================================
// RESIDENT OPERATIONS
// ============================================

export const residentAccess = (accessData, organizationId) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .residentAccess(accessData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success(`Access ${accessData.direction} logged successfully`);
      // Refresh access logs
      dispatch(fetchAllData('access_logs', organizationId, { page: 1, perPage: 10 }));
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to log access";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const addVehicleToResident = (residentCodeId, vehicleData) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .addVehicleToResident(residentCodeId, vehicleData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Vehicle added successfully");
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to add vehicle";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const addFamilyMemberToResident = (residentCodeId, familyData) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .addFamilyMemberToResident(residentCodeId, familyData)
    .then(response => {
      dispatch(actions.stopLoading());
      toast.success("Family member added successfully");
      return response.data;
    })
    .catch(error => {
      var message = error.response?.data?.message || "Failed to add family member";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};



export const initializeSubscription = (organization_id, plan_id, callback_url) => dispatch => {
  dispatch({ type: 'dashboard/startCall', payload: { callType: 'action' } });
  return billingCrud
    .initializeSubscription(organization_id, { plan_id, callback_url })
    .then(response => {
      const { authorization_url } = response.data;
      // Redirect to Paystack payment page
      window.location.href = authorization_url;
      return response.data;
    })
    .catch(error => {
      const message = error.response?.data?.message || "Failed to initialize payment";
      toast.error(message);
      throw error;
    });
};

export const startTrial = (organization_id, plan_id) => dispatch => {
  return billingCrud
    .startTrial(organization_id, { plan_id })
    .then(response => {
      toast.success("Free trial started! Enjoy 7 days of full access.");
      return response.data;
    })
    .catch(error => {
      const message = error.response?.data?.message || "Failed to start trial";
      toast.error(message);
      throw error;
    });
};